import { useEffect, useRef, useState } from "react";
import "./QrStyles.css";

import QrScanner from "qr-scanner";
import QrFrame from "../../assets/qr-image.png";

const QrReader = ({ onScanSuccess, onScanFail, scannedResult }) => {
  const scanner = useRef();
  const videoEl = useRef(null);
  const qrBoxEl = useRef(null);
  const [qrOn, setQrOn] = useState(true);
  const [isEnvironmentCamera, setIsEnvironmentCamera] = useState(true);

  useEffect(() => {
    if (videoEl?.current && !scanner.current) {
      scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
        onDecodeError: onScanFail,
        preferredCamera: isEnvironmentCamera ? "environment" : "user",
        highlightScanRegion: true,
        highlightCodeOutline: true,
        overlay: qrBoxEl?.current || undefined,
      });

      scanner?.current
        ?.start()
        .then(() => setQrOn(true))
        .catch((err) => {
          if (err) setQrOn(false);
        });
    }

    return () => {
      if (!videoEl?.current) {
        scanner?.current?.stop();
      }
    };
  }, [isEnvironmentCamera]);

  useEffect(() => {
    if (!qrOn)
      alert(
        "La cámara está bloqueada o no es accesible. Por favor, permite el acceso a la cámara en los permisos de tu navegador y recarga la página."
      );
  }, [qrOn]);

  const handleCameraChange = () => {
    setIsEnvironmentCamera((prevState) => !prevState);
    scanner.current.setCamera(isEnvironmentCamera ? "user" : "environment");
  };

  return (
    <div className="qr-reader">
      <video ref={videoEl}></video>
      <div ref={qrBoxEl} className="qr-box">
        <img
          src={QrFrame}
          alt="Qr Frame"
          width={150}
          height={150}
          className="qr-frame"
        />
      </div>
      {scannedResult && (
        <p
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 99999,
            color: "white",
            padding: "2px",
          }}
        >
          {scannedResult}
        </p>
      )}

      <button
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          zIndex: 99999,
          padding: "2px 5px",
          backgroundColor: "#0446aa",
          color: "white",
        }}
        onClick={handleCameraChange}>
        <i className="fas fa-sync-alt"></i>
      </button>
    </div>
  );
};

export default QrReader;